import React, { FC, useState } from "react";
import { AddIcon, SearchIcon } from "../../assets/icons";
import Input from "../../components/UI/input/GgInput";
import Button from "../../components/UI/button/GgButton";
import Modal from "../../components/modal/Modal";
import AddUser from "./AddUser";

interface IHeader {
  searchItems: (value: string) => void;
  data: any;
  setUserData: (data: any) => void
  handleSave?: (e: any) => void
  showModal: boolean;
  setShowModal?: (data: boolean) => void
  actionData?: any
}

const Header: FC<IHeader> = ({ searchItems, data, setUserData, handleSave, showModal, setShowModal, actionData}) => {
  return (
    <header className="users-header">
      <div className="title">Assign Roles</div>
      <div style={{ display: "flex" }}>
        <Input
          id="search"
          onChange={(value) => searchItems(value)}
          type="text"
          icon={<SearchIcon />}
          placeholder="Search users"
        />
        {actionData?.add ? (
          <Button
          icon={{ leftIcon: <AddIcon className="icon" /> }}
          stylesType="round"
          style={{ "marginLeft": "1rem", "marginBottom": "1rem" }}
          onPress={() => setShowModal && setShowModal(true)}
        />
        ): ""}
      </div>
      <Modal
        show={showModal}
        onClose={() => {
          setShowModal && setShowModal(false);
          setUserData({
            name: "",
            email: "",
            password: "",
            role: [],
          });
        }}
        title="Add User"
      >
        <AddUser
          data={data}
          setUserData={setUserData}
          handleSave={handleSave}
        />
      </Modal>

    </header>
  );
};

export default Header;
